export const headerContract = {
    title: 'Gestion de contrat',
    submodules: [
        createData(0, "Contrat Personnel", "/contract_user"),
        createData(1, "Contrat Stagiaire", "/contract_stg"),
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref};
}